<nz-badge [nzCount]="cardData.alarm_count" [nzOverflowCount]="100" class="w-full"
    [nzOffset]="[cardData.alarm_count > 10 ? -14 : -8, 10]"
    [routerLink]="!feUtil.roleService.hasRole('Security') ? ['/assets/',cardData?.asset_id] : null">
    <nz-card [nzBordered]="false" [ngClass]="cardData.alarm_count > 0 ? 'text-danger' : 'text-[#009A2F]'"
        class="min-h-[180px] mb-1" style="zoom:90%">
        <div class="flex items-center justify-between text-gray-600">
            <div>
                <i nz-icon nzType="hezky:Location" style="font-size: 16px !important;" nzTheme="outline"
                    class="mr-2"></i>
                <span class="text-sm font-normal">{{ cardData?.display_name}}</span>
            </div>
            <span [nzTooltipColor]="'#fff'" nz-tooltip [nzTooltipTitle]="cardData?.battery + '%'"
                style="font-size: 1.6rem;" class="cursor-pointer"
                *ngIf="cardData?.battery > 0 && cardData?.battery <= 20" nz-icon [nzType]="'hezky:Battery_Low_Red'"
                nzTheme="outline"></span>
        </div>
        <div class="text-lg font-semibold text-gray-600 cursor-pointer" style="margin-bottom: 6px;" nz-typography
            nzEllipsis [title]="cardData?.asset_name">
            {{ cardData?.asset_name }}
        </div>
        <div class="flex items-center justify-start gap-2 text-xs w-full">
            <div class="flex items-center justify-start w-full gap-x-2">
                <p *ngIf="isTemperature" class="m-0">
                    <span class="text-xs">24H
                        {{ feUtil.getFormattedTemp(cardData?.max_temp,'temperature') }} |
                        {{ feUtil.getFormattedTemp(cardData?.min_temp,'temperature') }}
                    </span>
                </p>
                <span *ngIf="isTemperature && isPressure">|</span>
                <p *ngIf="isPressure" class="m-0">
                    <span class="text-xs">24H
                        {{ feUtil.getFormattedTemp(cardData?.max_pressure,'pressure') }} |
                        {{ feUtil.getFormattedTemp(cardData?.min_pressure,'pressure') }}
                    </span>
                </p>
            </div>
        </div>
        <div
            class="flex items-center justify-start mx-0 flex-nowrap scroll-smooth overflow-x-auto no-scrollbar overflow-y-hidden gap-2">
            <ng-container *ngIf="cardData?.sensors && cardData?.sensors?.length > 0">
                <ng-container *ngFor="let sensor of cardData?.sensors; trackBy: feUtil.trackByFn; let even = even">
                    <div *ngIf="isTemperature" class="flex flex-nowrap items-center gap-x-1">
                        <div class="flex flex-nowrap">
                            <i nz-icon style="font-size: 28px !important; margin-top: 0.9px;"
                                [nzType]="'hezky:temperature'" nzTheme="outline"></i>
                            @if (sensor?.sensor_type_abbreviation) {
                            <span class="flex flex-col items-center justify-center gap-0 leading-none">
                                <ng-container *ngIf="sensor?.sensor_type_abbreviation as abbr">
                                    <small *ngFor="let char of abbr.split('');"
                                        [ngClass]="{'text-xsm py-0.5' : abbr.length == 2, 'text-[9px]' : abbr.length == 3 }"
                                        class="font-semibold">
                                        {{ char }}
                                    </small>
                                </ng-container>
                            </span>
                            }
                            <ng-container *ngIf="sensor?.is_offline && isTemperature; else checkModuleFail">
                                <div class="flex flex-nowrap items-center gap-x-2 ml-1.5">
                                    <i nz-icon nz-tooltip nzTooltipTitle="Offline" nzTooltipPlacement="top"
                                        nzTooltipColor="#fff" class="text-danger cursor-pointer text-3xl"
                                        nzType="hezky:Sensor_Offline" nzTheme="outline"></i>
                                </div>
                            </ng-container>
                            <ng-template #checkModuleFail>
                                <ng-container
                                    *ngIf="isTemperature && sensor?.show_error?.includes('temperature'); else showTemperature">
                                    <div class="flex flex-nowrap items-center gap-x-2 ml-1.5">
                                        <i nz-icon nz-tooltip
                                            [nzTooltipTitle]="'Temperature Module Not Working, ' + 'Last Reading: ' + (sensor?.temperature_date | date:'dd/MM/yyyy HH:mm:ss')"
                                            nzTooltipPlacement="top" nzTooltipColor="#fff"
                                            class="text-danger cursor-pointer text-3xl" nzType="hezky:Module_Fail"
                                            nzTheme="outline"></i>
                                    </div>
                                </ng-container>
                                <ng-template #showTemperature>
                                    <span style="font-size: 31px;" class="font-normal text-nowrap ml-1.5">
                                        {{ feUtil.getFormattedTemp(sensor?.temperature,'temperature') }}
                                    </span>
                                </ng-template>
                            </ng-template>
                        </div>
                        <span class="text-4xl font-light mb-1" *ngIf="even && cardData?.sensors?.length > 1">
                            &nbsp;|</span>
                    </div>
                    <div *ngIf="isPressure" class="flex flex-nowrap items-center gap-x-2">
                        <span class="text-4xl font-light mb-1" *ngIf="isTemperature"> &nbsp;|</span>
                        <div class="flex flex-nowrap">
                            <i nz-icon style="font-size: 29px !important;" [nzType]="'hezky:pressure'"
                                nzTheme="outline"></i>
                            @if (sensor?.sensor_type_abbreviation) {
                            <span class="flex flex-col items-center justify-center gap-0 leading-none pl-1 pr-2">
                                <ng-container *ngIf="sensor?.sensor_type_abbreviation as abbr">
                                    <small *ngFor="let char of abbr.split('');"
                                        [ngClass]="{'text-xsm py-0.5' : abbr.length == 2, 'text-[9px]' : abbr.length == 3 }"
                                        class="font-semibold">
                                        {{ char }}
                                    </small>
                                </ng-container>
                            </span>
                            }
                            <ng-container *ngIf="sensor?.is_offline && isPressure; else checkModuleFailPressure">
                                <div class="flex flex-nowrap items-center">
                                    <i nz-icon nz-tooltip nzTooltipTitle="Offline" nzTooltipPlacement="top"
                                        nzTooltipColor="#fff" class="text-danger cursor-pointer text-3xl"
                                        nzType="hezky:Sensor_Offline" nzTheme="outline"></i>
                                </div>
                            </ng-container>
                            <ng-template #checkModuleFailPressure>
                                <ng-container
                                    *ngIf="isPressure && sensor?.show_error?.includes('pressure'); else showPressure">
                                    <div class="flex flex-nowrap items-center gap-x-2 ml-1.5">
                                        <i nz-icon nz-tooltip
                                            [nzTooltipTitle]="'Pressure Module Not Working, ' + 'Last Reading: ' + (sensor?.pressure_date | date:'dd/MM/yyyy HH:mm:ss')"
                                            nzTooltipPlacement="top" nzTooltipColor="#fff"
                                            class="text-danger cursor-pointer text-2xl" nzType="hezky:Module_Fail"
                                            nzTheme="outline"></i>
                                    </div>
                                </ng-container>
                                <ng-template #showPressure>
                                    <span style="font-size: 31px;" class="font-normal text-nowrap ml-1.5">
                                        {{ feUtil.getFormattedTemp(sensor?.pressure,'pressure') }}
                                    </span>
                                </ng-template>
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!cardData?.sensors || cardData?.sensors.length === 0">
                <div class="w-full min-h-[95px] flex place-content-center">
                    <span class="font-semibold">No sensors data found!</span>
                </div>
            </ng-container>
        </div>
        <div *ngIf="cardData?.reading_on && cardData?.reading_on !== 'Invalid date'"
            class="text-gray-600 flex gap-x-2 text-xs font-semibold mt-3">
            <div>
                <i nz-icon nzType="calendar" nzTheme="outline"></i>
                {{ cardData?.reading_on | gDate: "MMM d, y" }}
            </div>
            <div>
                <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                {{ cardData?.reading_on | gDate: "HH:mm:ss" }}
            </div>
        </div>
    </nz-card>
</nz-badge>